module.exports = __webpack_public_path__ + "img/Weapon_47.a55d3556.png";